import { EncodingMethodsTypes, EncodingMetadataType } from "../../../utils/enum/enum";
import { SGTIN96PartitionToCompanyPrefix } from "../../../utils/validations/validations";

function getFieldLabel(field: string): string {
  const result = field.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

function getEncodingMetadataFields(
  method: EncodingMethodsTypes
): Record<string, { type: EncodingMetadataType }> {
  if (method === EncodingMethodsTypes.SGTIN96) {
    return {
      "partition": {  type: EncodingMetadataType.NUMBER },
      "filter": {  type: EncodingMetadataType.NUMBER },
      "companyPrefix": {  type: EncodingMetadataType.STRING }
    };
  } if (method === EncodingMethodsTypes.LOOKUP) {
    return {
      "epcFilter": {  type: EncodingMetadataType.STRING }
    }
  }

  return {};
};

function getSGTIN96MetadataError(data: Record<string, string | number>): string | undefined {
  const { partition = "-", filter = "-", companyPrefix = "-" } = data;
  const partitionString = partition.toString();
  const filterString = filter.toString();
  const companyPrefixString = companyPrefix.toString();
  const partitionInt = parseInt(partitionString, 10)

  if (partitionString === "" || /\D/.test(partitionString)) {
    return "Partition code must be a non-negative integer"
  }
  if (partitionInt > 6) {
    return "Partition code must be smaller or equal to 6"
  }
  if (filterString === "" || /\D/.test(filterString)) {
    return "Filter must be a non-negative integer"
  }
  if (parseInt(filterString, 10) > 7) {
    return "Filter must be smaller or equal to 7"
  }
  if (companyPrefixString === "" || /\D$/.test(companyPrefixString)) {
    return "Company prefix must be a non-negative integer"
  }
  const maximumValue = SGTIN96PartitionToCompanyPrefix.get(partitionInt) || 0;
  if (parseInt(companyPrefixString, 10) >= maximumValue) {
    return `Company prefix must be smaller than ${maximumValue}`
  }
  return undefined;
};

function getLookupMetaDataError(data: Record<string, string | number>): string | undefined {
  const { epcFilter = "" } = data;
  const epcFilterString = epcFilter.toString().trim();

  if (epcFilterString === "") {
    return undefined;
  }
  // Must have 1–4 segments, separated by '|'
  // Each segment can contain only letters or digits (no spaces, symbols, etc.)
  // Example of valid: 22|ss|tt|008
  const regex = /^[a-f0-9]{1,24}(\|[a-f0-9]{1,24}){0,3}$/i;

  if (!regex.test(epcFilterString)) {
    return (
      "EPC Filter may have up to 3 segments separated by 3 '|' character. " +
      "Each segment can contain only hexadecimal characters and be at most 24 characters long. " +
      "Example of valid filters: 22|aa|b8|008"
    );
  }

  return undefined;
}


export {
  getFieldLabel,
  getEncodingMetadataFields,
  getSGTIN96MetadataError,
  getLookupMetaDataError
}